import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import EditableCell from 'main/components/show/cuesheet/editableCell.jsx';
import ColumnMenu from 'main/components/show/grid/columnHeaderCell/dataColumnMenu.jsx';

/**
 * Data header cell
 *
 */
export default React.createClass({
  displayName: 'GridDataColumnHeaderCell',

  propTypes: {
    column: React.PropTypes.any.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
  },

  render() {
    return (
      <div>
        <div className="grid-column-title">
          <EditableCell
            onSelect={this._select}
            onStartEdit={this._startEditing}
            onStopEdit={this._stopEditing}
            text={this._getCellText()}
            resizeWhenEditing={true}
            {...this.props}
          />
          <ColumnMenu
            hide={this.props.isEditing}
            column={this.props.column}
            user={this.props.user}
          />
        </div>
      </div>
    );
  },

  _getColumnId() {
    return this.props.column.get('_id');
  },

  _getCellText() {
    return this.props.column.get('title');
  },

  _select() {
    CuesheetCellActions.selectHeaderCell(this._getColumnId());
  },

  _startEditing() {
    CuesheetCellActions.startEditingHeaderCell(this._getColumnId());
  },

  _stopEditing(heightAndText) {
    CuesheetCellActions.saveHeaderCellChanges(
      this._getColumnId(),
      heightAndText.text,
    );
  },
});
